// import axiosInstance from "./AxiosInstance"

// // Get content list (e.g., for viewing all content items)
// export function getContentList(pagination, pageid,search_by = "", search_keyword = "" ) {
//   return axiosInstance.post("/content/contentList", { pagination, pageid,search_by,search_keyword})
// }

// export function addContent(formData) {
//     return axiosInstance.post("/content/addContent", formData, {
//       headers: {
//         "Content-Type": "multipart/form-data", // Important for file uploads
//       },
//     })
//   }
  
//   // Edit content in the Content Bank
//   export function editContent(formData) {
//     return axiosInstance.post("/content/editContent", formData, {
//       headers: {
//         "Content-Type": "multipart/form-data", // Important for file uploads
//       },
//     })
//   }

// // Delete content from the Content Bank
// export function deleteContent(contentId) {
//   return axiosInstance.post("/content/deleteContent", {
//     content_id: contentId,
//   })
// }

// // Send content (e.g., to users or system)
// export function sendContent(sendType) {
//   return axiosInstance.post("/content/contentSend", {
//     send_type: sendType,
//   })
// }

// // Optional: Format content data (like formatImportLeads)
// export function formatContentList(data) {
//   if (!data || !Array.isArray(data)) {
//     return []
//   }

//   return data.map((item) => ({
//     content_id: item.content_bank_id || item.content_id || item.id,
//     content_title: item.content_title,
//     content_file: item.content_file,
//     video_link: item.video_link,
//     disease_ids: item.disease_ids, // optional if used
//     diseases: item.diseases || [], // ✅ include full disease object array
//     content_type: item.content_type,
//     created_at: item.created_at,
//     updated_at: item.updated_at,
//   }))
// }
import axiosInstance from "./AxiosInstance"

// Get content list (e.g., for viewing all content items)
export function getContentList(pagination, pageid, search_by = "", search_keyword = "",sort_by ="", sort_order) {
  return axiosInstance.post("/content/contentList", { pagination, pageid, search_by, search_keyword ,sort_by, sort_order})
}

export function addContent(formData) {
  return axiosInstance.post("/content/addContent", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Important for file uploads
    },
  })
}

// Edit content in the Content Bank
export function editContent(formData) {
  return axiosInstance.post("/content/editContent", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Important for file uploads
    },
  })
}

// Delete content from the Content Bank
export function deleteContent(contentId) {
  return axiosInstance.post("/content/deleteContent", { content_id: contentId })
}

// Send content (e.g., to users or system)
export function sendContent(payload) {
  return axiosInstance.post("/content/contentSend", payload)
}

// Optional: Format content data (like formatImportLeads)
export function formatContentList(data) {
  if (!data || !Array.isArray(data)) {
    return []
  }
  return data.map((item) => ({
    content_id: item.content_bank_id || item.content_id || item.id,
    content_title: item.content_title,
    content_file: item.content_file,
    video_link: item.video_link,
    disease_ids: item.disease_ids, // optional if used
    diseases: item.diseases || [], // ✅ include full disease object array
    content_type: item.content_type,
    created_at: item.created_at,
    updated_at: item.updated_at,
  }))
}

